import { animate, inView } from './vendor.min.js';
import { getHeadingKeyframe } from './theme.js';

class RichContent extends HTMLElement {
  connectedCallback() {
    const heading = this.querySelector('[reveal-on-scroll="true"]');

    if (!heading || !window.matchMedia('(prefers-reduced-motion: no-preference)').matches) {
      return;
    }

    inView(
      this,
      () => {
        const headingKeyframe = getHeadingKeyframe(heading);

        if (headingKeyframe.length > 0) {
          animate(...headingKeyframe);
        }
      },
      { margin: '0px 0px -100px 0px' }
    );
  }
}

if (!window.customElements.get('rich-content')) {
  window.customElements.define('rich-content', RichContent);
}
